import React, { useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminAreaSwitcher from "../../../../shared/components/AdminAreaSwitcher";

export default function AdminLayout({ children }) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="admin-layout-container">

      {/* Pass menuOpen + setMenuOpen to Sidebar */}
      <AdminSidebar
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
      />

      {/* Main content container */}
      <div
        className="admin-layout-content"
        onClick={() => {
          if (menuOpen) setMenuOpen(false);
        }}
      >
        <AdminAreaSwitcher />
        {children}
      </div>
    </div>
  );
}
